export default {
  index: { method: 'get', url: 'algorithm/ambience-allocation/rules' },
  show: { method: 'get', url: 'algorithm/ambience-allocation/rules/{id}' },
  store: { method: 'post', url: 'algorithm/ambience-allocation/rules' },
  update: { method: 'put', url: 'algorithm/ambience-allocation/rules/{id}' },
  duplicate: { method: 'post', url: 'algorithm/ambience-allocation/rules/{id}/duplicate' },
  toggle: { method: 'post', url: 'algorithm/ambience-allocation/rules/{id}/toggle' },
  destroy: { method: 'delete', url: 'algorithm/ambience-allocation/rules/{id}' },
}
